// extracted by mini-css-extract-plugin
export var actionButton = "_rc-0";
export var actionMenuContainer = "_rc-i";
export var bubble = "_rc-2";
export var bubbleActionMenu = "_rc-j";
export var bubbleContext = "_rc-6";
export var bubbleItems = "_rc-7";
export var customer = "_rc-3";
export var divider = "_rc-8";
export var fileList = "_rc-9";
export var hiddenComment = "_rc-o";
export var infoAbove = "_rc-a";
export var internal = "_rc-4";
export var lightActionButton = "_rc-1";
export var link = "_rc-b";
export var merchant = "_rc-5";
export var message = "_rc-c";
export var profilePicture = "_rc-e";
export var quillToolbarContainer = "_rc-f";
export var senderDate = "_rc-g";
export var senderDateCustomer = "_rc-h";
export var senderName = "_rc-d";
export var time = "_rc-k";
export var uploadedImage = "_rc-l";
export var username = "_rc-m";
export var xsmall = "_rc-n";